import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useUser } from "@/context/UserContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { checkAuth } = useUser();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post(
          "/auth/session",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        // Clean the hash so React Router picks up new state
        window.history.replaceState(null, "", "/dashboard");
        await checkAuth();
        toast.success(`Welcome, ${data.name.split(" ")[0]}!`);
        navigate("/dashboard", { replace: true, state: { user: data } });
      } catch (err) {
        toast.error("Sign-in failed. Please try again.");
        navigate("/", { replace: true });
      }
    })();
  }, [location, navigate, checkAuth]);

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center gap-3 text-slate-500"
      data-testid="auth-callback"
    >
      <Loader2 className="animate-spin" size={24} />
      <p className="text-sm">Finishing sign-in…</p>
    </div>
  );
};
